import React, { Fragment } from "react";

export default (
  <>
    <path d="M22.3 23.8c.5-.5.5-1.2 0-1.7l-9.8-10 9.8-10c.4-.5.4-1.2 0-1.7s-1.2-.5-1.6 0L10.1 11.2c-.4.5-.4 1.2 0 1.7l.1.1s0 .1.1.1l10.4 10.7c.4.4 1.2.4 1.6 0z" />
    <path d="M13.8 23.8c.5-.5.5-1.2 0-1.7L4 12.1l9.8-10c.4-.5.4-1.2 0-1.7s-1.2-.5-1.6 0L1.6 11.2c-.4.5-.4 1.2 0 1.7l.1.1s0 .1.1.1l10.4 10.7c.4.4 1.2.4 1.6 0z" />
  </>
);
